import React from 'react';
import { useTranslation } from 'react-i18next';

import { ModalWindow } from 'components/modal-window';
import { Typography } from 'components/typography';
import { TypographyVariants } from 'constants/typography-variants';
import { Button } from 'components/button';

import { useStyles } from './styles';

export const CorrectionModalWindow = ({ address, handleClick }: { address: string, handleClick: () => void }): JSX.Element => {
    const { t } = useTranslation();

    const { modalWindowLoading } = useStyles();

    return (
        <ModalWindow wrapperClassName={modalWindowLoading}>
            <Typography variant={TypographyVariants.h1}>
                {t('shipping-address-correction-modal-window-title')}
            </Typography>

            <Typography variant={TypographyVariants.h2}>
                {address}
            </Typography>

            <Button typographyText={t('shipping-address-correction-modal-window-button')} onClick={handleClick} />
        </ModalWindow>
    );
};
